export default "__VITE_ASSET__e3d2c7ce__"